import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

interface LoadingCenterProps {
  height?: number | string;
}

const LoadingCenter: React.FC<LoadingCenterProps> = ({ height = 200 }) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height }}>
    <CircularProgress />
  </Box>
);

export default LoadingCenter;
